import React from 'react';
import { Colors, Metrics } from '@origin-digital/style-guide';
import styled from 'styled-components';
import { useInView } from 'react-intersection-observer';
import { IResultTabProps } from './ResultTab.types';
import { ImageHeader, ImageHeaderImage } from './ResultTabComponents/ImageHeader';
import SystemDetails from './ResultTabComponents/SystemDetails';
import { PackagesResult } from './ResultTabComponents/PackageResult/PackageResult';
import { StickyBanner } from '../../../../../components/StickyBanner/StickyBanner';
import { SolarPackageReceipt } from './ResultTabComponents/SolarPackageReceipt/SolarPackageReceipt';
import { isIE11 } from '../../../../../utils/isIE/isIE11';

const HR = styled.hr`
  height: 32px;
  border: none;
  background-color: ${Colors.GREY8};
  margin: ${Metrics.Spacing.M_Y_LG}px 0;
`;

export const ResultTab = (props: IResultTabProps) => {
  const [ref, inView] = useInView({ threshold: 0.5 });
  const { onShowDisclaimer, submit, values, recommendation } = props;
  const { solarSystem } = recommendation;
  const imageSize: ImageHeaderImage = solarSystem!.size.toLocaleLowerCase() as ImageHeaderImage;
  return (
    <React.Fragment>
      <ImageHeader {...props} image={imageSize} />
      <SystemDetails system={solarSystem!} />
      <HR />
      <PackagesResult packageName={solarSystem.package} values={values} submit={submit} />
      <HR />
      <div ref={ref}>
        <SolarPackageReceipt
          selected={recommendation}
          postcode={values.postcode}
          usagePercentDuringDay={values.usagePercentDuringDay}
          averageBill={values.averageBill}
          onShowDisclaimer={onShowDisclaimer}
        />
      </div>
      {recommendation && !inView && !isIE11() ? (
        <StickyBanner
          selected={recommendation}
          postcode={values.postcode}
          usagePercentDuringDay={values.usagePercentDuringDay}
          averageBill={values.averageBill}
        />
      ) : null}
    </React.Fragment>
  );
};
